import React, { useContext } from 'react';
import { PapiUser } from '@wix/da-papi-types';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import CommentThread from '@wix/da-shared-react/pkg/CommentThread';
import { isGroup } from '@wix/da-shared-react/pkg/User/helpers';
import ThreadOrderSelect from '@wix/da-shared-react/pkg/CommentThread/_partials/ThreadOrderSelect';
import { CommentableTypes } from '@wix/da-shared-react/pkg/Comment/redux/types';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import WidgetBox, { Props as WidgetBoxProps } from '../_partials/WidgetBox';
import s from './ProfileComments.scss';

export type Props = {
  profileOwnerUser: PapiUser;
  isOwner: boolean;
  totalCount: number;
} & Pick<WidgetBoxProps, 'moduleId' | 'section' | 'zone' | 'widgetRemove'>;

const ProfileCommentsBox: React.FC<Props> = ({
  widgetRemove,
  isOwner,
  section,
  zone,
  totalCount,
  moduleId,
  profileOwnerUser,
}) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const { isLoggedIn } = useContext(SessionContext);

  return (
    <WidgetBox
      section={section}
      zone={zone}
      header={isGroup(profileOwnerUser)
        ? t('widgets.profileComments.group.header')
        : t('widgets.profileComments.header')
      }
      headerExtras={
        isLoggedIn && isMobile ? (
          <ThreadOrderSelect
            commentableTypeId={CommentableTypes.COMMENT_USER}
            commentableItemId={profileOwnerUser.userId}
          />
        ) : undefined
      }
      count={totalCount}
      moduleId={moduleId}
      widgetRemove={widgetRemove}
      dataHook={BiDataHook.WIDGET_PROFILE_COMMENTS}
    >
      <div className={s['root']}>
        <BiLoggerContextProvider
          value={{ widgetname: 'comments', sectionname: 'comments' }}
        >
          <CommentThread
            commentableTypeId={CommentableTypes.COMMENT_USER}
            commentableItemId={profileOwnerUser.userId}
            useCardLayout
            postbox="top"
            statsAndControls={'off'}
          />
        </BiLoggerContextProvider>
      </div>
    </WidgetBox>
  );
};
ProfileCommentsBox.displayName = 'ProfileCommentsBox';

export default ProfileCommentsBox;
